import { render, staticRenderFns } from "./BrokerPickerHandler.vue?vue&type=template&id=36d68ac7&scoped=true&"
import script from "./BrokerPickerHandler.vue?vue&type=script&lang=js&"
export * from "./BrokerPickerHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d68ac7",
  null
  
)

export default component.exports